import { createStore, combineReducers, applyMiddleware } from 'redux';
import promiseMiddleware from 'redux-promise';
import thunk from 'redux-thunk';
import { routerReducer } from 'react-router-redux';
import Immutable from 'immutable';

// import reducers from './reducers/reducers';
import global from './reducers/global'
import user from './reducers/user'
import screen from './reducers/screen'
import session from './reducers/session'
import service from './reducers/service'
import message from './reducers/message'

let store = null
const dynamicReducers = {}

const errorMiddleWare = store => next => action => {
  if(!action.error || (action.error && action.type === 'GLOBAL_FAILURE'))
  {
    next(action);
  }
}

function lastAction(state = null, action) {
  return action;
}

function getAllReducers() {
  return combineReducers({
    global,
    user,
    screen,
    session,
    service,
    message,
    routing: routerReducer,
    dynamicReducers,
    lastAction
  })
}

//CREATE STORE------------------------------------------------------------

export function createAppStore() {
  let createStoreWithMiddleware = applyMiddleware(
    promiseMiddleware, thunk, errorMiddleWare
  )(createStore)

  let storeArgs = [getAllReducers()]
  // @if DEPLOYMENT_ENV='dev'
  storeArgs.push(window.devToolsExtension && window.devToolsExtension());
  // @endif

  store = createStoreWithMiddleware(...storeArgs)
  return store
}

//DYNAMIC REDUCERS--------------------------------------------------------

export function addDynamicReducer(name, reducer) {
  if(dynamicReducers[name])
    console.warn('addDynamicReducer(): warning dynamic reducer with name ' + name + ' already exists')

  dynamicReducers[name] = reducer
  store.replaceReducer(getAllReducers())
}

export function removeDynamicReducer(name) {
  if(!dynamicReducers[name])
    console.warn('removeDynamicReducer(): warning dynamic reducer with name ' + name + ' does not exists')

  // delete dynamicReducers[name]
  // when i deleted the reducer, redux printed an error in the console
  // so instead of completely deleting the reducer, i will just clear it
  dynamicReducers[name] = (state) => Immutable.Map({})
  store.replaceReducer(getAllReducers())
}

//HELPERS----------------------------------------------------------------

export function asyncAction(handler) {
  return (...args) => {
    return (_dispatch, _getState) => {
      return handler(...args)
    }
  }
}


export function dispatch(...args) {
  const numArgs = args.length
  const a0 = args[0]

  if(typeof a0 == 'function') {
    console.assert(numArgs===1, 'unexpected dispatch args')
    return store.dispatch(a0) //a0 is an action
  }
  else if(typeof a0 == 'string') {
    const type = a0
    if(numArgs === 1) {
      return store.dispatch({type:type})
    }
    else {
      let payload = args[numArgs-1]
      //loop through the args building up the payload object
      for(let i=numArgs-2; i>=1; i--) {
        // console.assert(typeof args[i] == 'string', 'unexpected dispatch args')
        payload = {[args[i]]:payload}
      }
      return store.dispatch({type:type, payload:payload})
    }
  }
  else {
    throw new Error('unexpected dispatch args')
  }
}

export function tightenDispatch(...tighteningArgs) {
  return (...dispatchArgs) => {
    if(dispatchArgs.length === 1 && (typeof dispatchArgs[0] == 'function' || typeof dispatchArgs[0] == 'string')) //numArgs==1 && string is just sending {type}
      return dispatch(...dispatchArgs)
    else
      return dispatch(...tighteningArgs, ...dispatchArgs)
  }
}

export function getState(reducerName, ...getInArgs) {
  let state = store.getState()
  state = state && state['reducers']
  if(reducerName && !state[reducerName])
    console.warn('reducer with name "' + reducerName + '" does not exist')

  if(reducerName && getInArgs && getInArgs.length > 0)
    return state[reducerName].getIn(getInArgs)
  else if(reducerName)
    return state[reducerName]
  else
    return state
}

// @if DEPLOYMENT_ENV='dev'
window.Immutable = Immutable
window.dispatch = dispatch
window.gs = getState
// @endif

export function handleSend(state, payload) {
  // console.log('----------------')
  // console.log('>send', state.toJS())
  // console.log('  payload', payload)
  state = state.withMutations(_state => myDeepMapMerge(_state, Immutable.fromJS(payload)))
  // console.log('  <result', state.toJS())
  return state

  function myDeepMapMerge(a,b) {
    // console.log('b', b, b.toJS?b.toJS():'')

    if (!b) return a

    b.forEach((valB,key) => {
      const valA = a.get(key)
      if(!a.has(key) || !valA || valB == null) {
        // console.log('  ' + key + ' case1')
        a = a.set(key, Immutable.fromJS(valB))
      }
      else if(!isMergeable(valA) || !isMergeable(valB)) {
        // console.log('  ' + key + ' case2')
        a = a.set(key, Immutable.fromJS(valB))
      }
      else {
        // console.log('  ' + key + ' case3')
        a = a.mergeIn([key], myDeepMapMerge(a.get(key), valB))
      }
    })
    return a
  }

  function isMergeable(o) {
    return Immutable.Map.isMap(o) && !Immutable.OrderedMap.isOrderedMap(o)
  }
}
